import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { KhiimoriLogo } from '@/components/brand/KhiimoriLogo';

interface AuthPageLayoutProps {
  title: string;
  subtitle: string;
  children: ReactNode;
  alternatePrompt: string;
  alternateLinkTo: string;
  alternateLinkLabel: string;
  legalAction: string;
}

export function AuthPageLayout({
  title,
  subtitle,
  children,
  alternatePrompt,
  alternateLinkTo,
  alternateLinkLabel,
  legalAction,
}: AuthPageLayoutProps) {
  return (
    <main className="min-h-screen bg-khiimori-bg-primary px-4 py-8 sm:py-12">
      <div className="mx-auto w-full max-w-md">
        <div className="text-center mb-8">
          <div className="flex justify-center mb-4">
            <Link to="/" aria-label="Back to Khiimori home">
              <KhiimoriLogo size={72} className="rounded-2xl shadow-xl shadow-primary-500/20 transition-transform hover:scale-105" />
            </Link>
          </div>
          <p className="text-sm font-medium uppercase tracking-wider text-primary-400 mb-2">Khiimori</p>
          <h1 className="text-2xl font-semibold text-khiimori-text-primary mb-2">{title}</h1>
          <p className="text-khiimori-text-muted text-sm leading-relaxed max-w-sm mx-auto">{subtitle}</p>
        </div>

        <div className="bg-khiimori-bg-elevated/5 backdrop-blur-xl border border-khiimori-border/10 rounded-xl p-6 shadow-glass">
          {children}

          <p className="mt-6 pt-6 border-t border-khiimori-border/20 text-center text-sm text-khiimori-text-muted">
            {alternatePrompt}{' '}
            <Link
              to={alternateLinkTo}
              className="font-medium text-primary-400 hover:text-primary-300 transition-colors duration-150"
            >
              {alternateLinkLabel}
            </Link>
          </p>
        </div>

        <p className="text-center text-xs text-khiimori-text-muted mt-6 leading-relaxed">
          By {legalAction}, you agree to our Terms of Service and Privacy Policy.
        </p>
      </div>
    </main>
  );
}
